export function _time(): number {
    return Math.floor(new Date().getTime() / 1000);
}

export function formatLandingPageText(title: string): string {
    if (!title) {
        return title;
    }

    const shortCodes = ['location', 'age', 'gender', 'topic', 'keyword'];
    const SEA_FLAG = Boolean(window.__sea_landing_page__);
    const user = window.__sea_user__ || {};
    for (let i = 0; i < shortCodes.length; i++) {
        const key = shortCodes[i];
        let value = '';
        if (
            Object.prototype.hasOwnProperty.call(user, key) &&
            SEA_FLAG &&
            Boolean(user[key])
        ) {
            value = user[key];
            if (key === 'gender') {
                value = this.$t ? this.$t(user[key]) : user[key];
            }
            // remove html tag
            title = title.replace(
                new RegExp('<(/?|!?)(' + key + ')>', 'ig'),
                ''
            );
        } else {
            // remove html tag with content
            title = title.replace(
                new RegExp('<' + key + '.*>.*?</' + key + '>', 'ig'),
                ''
            );
        }
        title = title.replace('{' + key + '}', value);
    }
    return title;
}
